<nz-modal
  [(nzVisible)]="isVisible"
  [nzFooter]="null"
  nzTitle="Money Laundering Reporting Officer Details"
  [nzWidth]="900"
  (nzOnCancel)="modal.destroy()"
  class="individual-details-modal"
>
  <div class="details-modal-body" *nzModalContent>
    <div class="sidebar">
      <div class="flex-col-12">
        <nz-avatar [nzIcon]="'user'" class="avatar"></nz-avatar>
        <div>
          <div class="name-line">
            {{ individual?.firstName }}
            <span *ngIf="individual?.middleName"> {{ individual?.middleName }} </span>
            {{ individual?.lastName }}
          </div>
        </div>
      </div>

      <nz-divider class="divider-tight"/>
    </div>

    <div class="details-content">
      <nz-tabset>
        <nz-tab nzTitle="General">
          <div class="pad-24">

            <!-- Personal Details -->
            <div class="mb-2">
              <div class="section-title">Personal Details</div>
              <div class="section-box">

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>First name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.firstName }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Patronymic name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.middleName || '—' }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Last name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.lastName || '—' }}</span>
                  </div>
                </div>

 
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Former name</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.formerName || '—' }}</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- Contact Details -->
            <div class="mb-2">
              <div class="section-title">Contact Details</div>
              <div class="section-box">
                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Contact number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span *ngIf="getContactNumberPrefix">{{ getContactNumberPrefix }}</span> <span>{{ individual?.phone }}</span>
                  </div>
                </div>

                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Mobile number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span *ngIf="getMobNumberPrefix">{{ getMobNumberPrefix }}</span> <span>{{ mlro.officerMobNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Address Details -->
            <div *ngIf="individual?.address" class="mb-2">
              <div class="section-title">Address Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Postal code</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.address?.postalCode }}</span>
                  </div>
                </div>
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Country of citizenship</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ countryName }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>City</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.address?.city }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Street</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.address?.street }}</span>
                  </div>
                </div>

                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Building number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.address?.buildingNumber }}</span>
                  </div>
                </div>

                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">
                    <span>Office/Room number</span>
                  </div>
                  <div nz-col nzSpan="13" class="col-value">
                    <span>{{ individual?.address?.officeRoomNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </nz-tab>
        <nz-tab nzTitle="Documents">
          <div class="document-list">
            <div *ngIf="passport">
              <div class="document-group-title">
                <span>Copy of passport / ID document</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(passport)">{{ passport.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ passport.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
            
            <div *ngIf="policies">
              <div class="document-group-title">
                <span>AML, CTF and Sanctions policies, procedures, systems and controls</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(policies)">{{ policies.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ policies.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
            
            <div *ngIf="cv">
              <div class="document-group-title">
                <span>CV and certificates</span>
              </div>
              <div class="document-item">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(cv)">{{ cv.fileName }}</a>
                </div>
                <div>
                  <span class="document-date">{{ cv.createdAt| date:'dd.MM.yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</nz-modal>
